export default "__VITE_ASSET__eea6ac0e__"